module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Regular.ttf
// module id = 270
// module chunks = 0